import { getGrpcPromise } from '@monorepo/grpc';
import { OfferService } from '@spilca/order_ts/v1/order_web/offer_web_pb_service';
import { ListOfferBrandRequest } from '@spilca/order_ts/v1/order/model_offer_pb';
import { offerFilterConstructor } from '@monorepo/offers';

const getBrandsRequest = (d: any) => {
  const [, params] = d.queryKey;
  const getBrands = getGrpcPromise(OfferService.ListOfferBrand);
  const offerFilter = offerFilterConstructor(params, d.active);
  const request = new ListOfferBrandRequest();
  request.setFilter(offerFilter);
  return getBrands(request);
};

export default getBrandsRequest;
